import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';
import { TargetWrapper } from '../../design/transforms/target/target.wrapper';

export class AvroWrapper extends DatabaseWrapper {
	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.avro.ID;
		this.name = DatabaseEnum.avro.NAME;
		this.code = DatabaseEnum.avro.CODE;
		this.showClevel = true;
		//data object tabs
		this.showDataObjectPropertiesTab = true;
		this.isShowObjProperties = true;
		this.isFileType = true;
		this.showPropertiesTab = false;
    this.showDataDescription = false;
		this.equivalentTag = 'avid';
		this.importFileProperties();
		this.complexAttrDTyp_Ids = [11, 22, 33];
	}

	validateRepConn(repConnWrapper: RepConnWrapper): void {
		if (!repConnWrapper.repConn.conn.fileloc.length) {
			repConnWrapper.inValid_Cds.push('NO_FILELOC');
		}

		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}

		if (repConnWrapper.repConn.conn.ftpFlag == 'Y') {
			if (!repConnWrapper.repConn.conn.ftpHost.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_HOST');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_HOST');

			}
			if (!repConnWrapper.repConn.conn.ftpPort.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_PORT');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_PORT');

			}
			if (!repConnWrapper.repConn.conn.ftpUsr.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_CONN_USR');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_CONN_USR');

			}
			if (!repConnWrapper.repConn.conn.ftpPasswd.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_PASSWORD');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_PASSWORD');
			}
		}
	}

	getAttributeColumns(objectWrapper: ObjectWrapper,
		attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getClevel(objectWrapper, true),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getNotNullFlag(objectWrapper),
			this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
			// this.attributeTabulator.getPartitionflag(objectWrapper),
			// this.attributeTabulator.getOrderBy(objectWrapper,attributes),
			this.attributeTabulator.getDescription(objectWrapper),
		]
	}

	getSourceAttributeColumns(objectWrapper: ObjectWrapper, isComplex: boolean = false, isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false, isMax: boolean = false,component:any): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper,component),
		];
	}

	getTgt_Attr_LnkColumns(dbTyp_Id: number, tgtLoadType: string, targetWrapper: TargetWrapper): Array<any> {
		let columns: Array<any> = new Array<any>();

		columns.push(this.tgt_Attr_LnkTabulator.getTgt_dObj_Inst_Attr_Id(targetWrapper));
		columns.push(this.tgt_Attr_LnkTabulator.getTgtDTypNm(targetWrapper));
		columns.push(this.tgt_Attr_LnkTabulator.getSrcAttrNm(targetWrapper));
		columns.push(this.tgt_Attr_LnkTabulator.getSrcDTypNm(targetWrapper));
		columns.push(this.tgt_Attr_LnkTabulator.getValid_Cd(targetWrapper));

		return columns;
	}

	importFileProperties(): void {
		this.showAvroTypeGroup = true;
	}

	hideNotNullFlag(attribute): boolean {

		return this.complexAttrDTyp_Ids.indexOf(parseInt(attribute.attrDTyp_Id)) != -1;
	}

	hideAttrKeyTyp_Id(attribute): boolean {

		return this.complexAttrDTyp_Ids.indexOf(parseInt(attribute.attrDTyp_Id)) != -1;
	}

	readFileCutOffLength(type: string): number {
        return -1;
    }

}
